import localstore from 'store';
import { showError, showSuccess } from '../../../common/A1Alert/A1Alert';
import Api from '../../../helpers/Api';

export const SET_POLL_RESPONSES = 'SET_POLL_RESPONSES';
const setResponses = (json) => ({
    type: SET_POLL_RESPONSES,
    json,
});

export const SET_POLL_TOTAL_VOTES = 'SET_POLL_TOTAL_VOTES';
const setTotal = (total) => ({
    type: SET_POLL_TOTAL_VOTES,
    total,
});

export const SET_POLL_QUESTION = 'SET_POLL_QUESTION';
const setQuestion = (quets) => ({
    type: SET_POLL_QUESTION,
    quets,
});

export const SET_POLL_ID = 'SET_POLL_ID';
const setPollId = (pollId) => ({
    type: SET_POLL_ID,
    pollId,
});

export const SET_SELECTED_ID = 'SET_SELECTED_ID';
const setSelectedId = (selectedId) => ({
    type: SET_SELECTED_ID,
    selectedId,
});

export const SAVE_POLL_VOTE = 'SAVE_POLL_VOTE';
const setVote = (voteId) => ({
    type: SAVE_POLL_VOTE,
    voteId,
});


export const getPollDataIfNeeded = () => (dispatch, getState) => {
    const storePollId = getState().poll.pollId;

    if (storePollId) {
        // no need to fetch the data again
        // check if the user already voted for this poll, and get store his vote in the store if so
        if (storePollId === localstore.get('pollId')) {
            const voteId = localstore.get('voteId');

            dispatch(setVote(voteId));
        }

        return Promise.resolve(1);
    }

    return Api.progressGet(dispatch, 'api/v1/poll/get')

        .then((json) => {
            if (json.status === 'success') {
                const data = json.data;
                const myPromises = [
                    dispatch(setQuestion(data.title)),
                    dispatch(setPollId(data.pollId)),
                ];
                const arrayResponses = data.respostas;
                let total = 0;

                arrayResponses.forEach((resposta) => { total += parseInt(resposta.qtd, 10); });

                myPromises.push(dispatch(setTotal(total)));

                myPromises.push(dispatch(setResponses(arrayResponses)));

                // if the user already voted for this poll, get its vote and set it in the store
                if (data.pollId === localstore.get('pollId')) {
                    const voteId = localstore.get('voteId');

                    myPromises.push(dispatch(setVote(voteId)));
                }

                return Promise.all(myPromises);
            }

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            throw `getPollDataIfNeeded got error:${error}`;
        });
};

export const saveVote = () => (dispatch, getState) => {
    const store = getState();
    const pollId = store.poll.pollId;
    const localPollId = localstore.get('pollId');

    if (pollId === localPollId) {
        // This should never happen (as the button should be disabled once the user voted)
        return showError('O seu voto já foi computado para esse enquete.');
    }

    const voteId = store.poll.selectedId;

    const query = 'api/v1/poll/vote';

    const data = {
        pollId,
        voteId,
        referer: window.location.href,
    };

    return Api.progressPost(dispatch, query, data)
        .then((json) => {
            if (json.status === 'success') {
                showSuccess('Voto computado com sucesso!');

                // Set on storage
                localstore.set('pollId', pollId);

                localstore.set('voteId', voteId);

                return dispatch(setVote(voteId));
            }

            throw `error from server: ${json.message}`;
        }).catch((error) => {
            showError('Problema na comunicação com servidor, por favor tente novamente em alguns instantes');

            throw `saveVote got error:${error}`;
        });
};

export const selectId = (selectedId) => (dispatch) => {
    dispatch(setSelectedId(selectedId));
};
